var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.988,24A11.994,11.994,0,0,1,0,12,12,12,0,0,1,20.482,3.516,12,12,0,0,1,11.988,24Zm-2.28-7.2h0A16.911,16.911,0,0,0,12,21.552,16.89,16.89,0,0,0,14.292,16.8H9.708Zm7.056,0a18.8,18.8,0,0,1-1.656,4.271A9.626,9.626,0,0,0,20.3,16.8ZM3.7,16.8a9.591,9.591,0,0,0,5.2,4.271A18.8,18.8,0,0,1,7.236,16.8ZM17.232,9.6A20.2,20.2,0,0,1,17.4,12a20.206,20.206,0,0,1-.167,2.4h4.055A9.9,9.9,0,0,0,21.6,12a9.9,9.9,0,0,0-.312-2.4Zm-8.04,0A17.161,17.161,0,0,0,9,12a17.714,17.714,0,0,0,.192,2.4h5.616A17.711,17.711,0,0,0,15,12a17.184,17.184,0,0,0-.193-2.4Zm-6.48,0A9.944,9.944,0,0,0,2.4,12a9.947,9.947,0,0,0,.311,2.4H6.768A20.089,20.089,0,0,1,6.6,12a19.978,19.978,0,0,1,.168-2.4Zm12.4-6.673A18.793,18.793,0,0,1,16.764,7.2H20.3A9.627,9.627,0,0,0,15.108,2.928ZM12,2.448A16.9,16.9,0,0,0,9.708,7.2h4.584A16.882,16.882,0,0,0,12,2.448Zm-3.108.48A9.591,9.591,0,0,0,3.7,7.2h3.54A18.8,18.8,0,0,1,8.892,2.928Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCountry);
export default __webpack_public_path__ + "static/media/icon-country.a14948a133102e592a6b910f2eb2bfb9.svg";
export { ForwardRef as ReactComponent };